import { render, staticRenderFns } from "./SubCategoryFilter.vue?vue&type=template&id=a842d746&scoped=true&"
import script from "./SubCategoryFilter.vue?vue&type=script&lang=js&"
export * from "./SubCategoryFilter.vue?vue&type=script&lang=js&"
import style0 from "./SubCategoryFilter.vue?vue&type=style&index=0&id=a842d746&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a842d746",
  null
  
)

export default component.exports